import React, { Component } from 'react';
import './App.css';

import Layout from '@cjdev/visual-stack-redux/lib/layouts/ApplicationLayout';
import { Provider } from 'react-redux';
import { HomePage } from './HomePage';
import { AccessPage } from './AccessPage';
import { DeploymentsPage } from './DeploymentsPage'

import { ConnectedNavigation } from './Navigation';
import { ConnectedPageSelector, Page } from './PageSelector';

import { HOME_REGION, ACCESS_REGION, DEPLOYMENTS_REGION, NOT_FOUND_STATUS } from '../navigation';

import { store } from '../wiring'

const side = (<ConnectedNavigation />);

class App extends Component {
  render() {
    return (
      <Provider store = {store} >
        <Layout sideNav = {side} >
          <ConnectedPageSelector >
            <Page region={HOME_REGION}>
                <HomePage />
            </Page>
            <Page region={ACCESS_REGION}>
                <AccessPage />
            </Page>
            <Page region={DEPLOYMENTS_REGION}>
                <DeploymentsPage />
            </Page>
            <Page status={NOT_FOUND_STATUS}>
                <span>This is not a page"</span>
            </Page>
          </ConnectedPageSelector>
        </Layout>
      </Provider>
    );
  }
}

export { App };



// WEBPACK FOOTER //
// ./src/view/App.js